import React from "react";
import { useState, useEffect } from "react";
import {
  Container,
  AppBar,
  Typography,
  Toolbar,
  Link,
  Button,
  Box,
  List,
  Divider,
  Drawer,
  Card,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import "@fontsource/wallpoet";

import logo from "../../Assets/fort-worth-bbq-logo.png";
import Image from "mui-image";
const Navbar = () => {
  const [clicked, setclicked] = useState(false);

  const clickHandler = () => {
    setclicked(true);
  };

  const backHandler = () => [setclicked(false)];

  const list = () => (
    <Box
      sx={{ py: 7, width: "100%" }}
      anchor="left"
      role="presentation"
      onClick={backHandler}
      onKeyDown={{ backHandler }}
    >
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Link href="/" color="inherit" underline="none" sx={linkSX}>
          <Typography variant="h6">Home</Typography>
        </Link>
        <Link href="/menu" color="inherit" underline="none" sx={linkSX}>
          <Typography variant="h6">Smokin' BBQ Menu</Typography>
        </Link>
        <Link href="/bbqquote" color="inherit" underline="none" sx={linkSX}>
          <Typography variant="h6">Caterin' BBQ Quote</Typography>
        </Link>
        <Link href="/aboutus" color="inherit" underline="none" sx={linkSX}>
          <Typography variant="h6"> PitMaster</Typography>
        </Link>
        <Divider />
      </List>
    </Box>
  );

  const linkSX = {
    padding: "0 50px",
    alignItems: "center",
    fontFamily: "Wallpoet",
    // fontSize: "1.4rem",
    "&:hover": {
      color: "grey",
    },
  };
  return (
    <AppBar
      position="sticky"
      color="primary"
      sx={{
        backgroundColor: "primary.dark",
      }}
    >
      <Container
        sx={{
          alignItems: "center",
          height: "100px",
          display: "flex",
          justifyContent: "center",
        }}
        maxWidth="xl"
      >
        <Card
          sx={{
            flexShrink: 0,
            height: "100px",
            position: "relative",
            backgroundColor: "primary.dark",
            boxShadow: "0",
          }}
        >
          <Link href="/">
            <Image
              src={logo}
              duration="0"
              style={{
                height: "120px",
                width: "120px",
              }}
            />
          </Link>
        </Card>
        <Box
          sx={{
            display: {
              xs: "flex",
              md: "none",
              position: "absolute",
              left: "2%",
            },
          }}
        >
          <Button onClick={clickHandler}>
            <MenuIcon sx={{ color: "white", fontSize: "35px" }} />
          </Button>

          <Drawer
            sx={{
              color: "primary.dark",
            }}
            anchor="left"
            open={clicked}
            onClose={backHandler}
          >
            {list("left")}
          </Drawer>
        </Box>
        <Toolbar
          sx={{
            display: { xs: "none", md: "flex" },
          }}
        >
          <Link href="/" color="inherit" underline="none" sx={linkSX}>
            <Typography variant="h6">Home</Typography>
          </Link>
          <Link href="/menu" color="inherit" underline="none" sx={linkSX}>
            <Typography variant="h6">Smokin' BBQ Menu</Typography>
          </Link>
          <Link href="/bbqquote" color="inherit" underline="none" sx={linkSX}>
            <Typography variant="h6">Caterin' BBQ Quote</Typography>
          </Link>
          <Link href="/aboutus" color="inherit" underline="none" sx={linkSX}>
            <Typography variant="h6"> PitMaster</Typography>
          </Link>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
